import { inject, Injectable } from '@angular/core';
import { type Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { type AppConfig } from '../../types';

@Injectable({ providedIn: 'root' })
export class AppConfigService {
  private readonly http = inject(HttpClient);

  load(): Observable<AppConfig> {
    return this.http.get<AppConfig>(`api/v1/court/current/export-config`);
  }
}
